fragment ListBulkActionsFragment on TimelineEvent {
    id
    changeType
    changeTime
    entityName
    actor {
        ... on User {
            id
            name
        }
    }
    changes {
        id
        attribute
        newValue
    }
}
